import './ContentBuilderTemplate.scss';

import React from 'react';
import { forwardRefWithAs } from '../../../utils/types/PropsWithAsAttributes';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { FileCard } from '../../FileCard';
import { IRoot31 } from './models/CTI_31.props';
import { AxiosPromise } from 'axios';
import { BodyType } from '../ContentBuilder';

interface Props extends IRoot31 {
  onSubmitFileForm: (body: BodyType) => AxiosPromise<void>;
  recaptchaKey: string;
}
export const ContentBuilderTemplate = forwardRefWithAs<Props>(props => {
  const {
    type,
    title,
    columnI = [],
    columnII = [],
    onSubmitFileForm,
    recaptchaKey,
    contentId,
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <Typography.Title
        size="lg"
        className={cnContentBuilderTemplate('Title')}
        as="h2"
      >
        {title}
      </Typography.Title>
      <Grid
        breakpoints={{
          desktop: { cols: 2, colGap: 'xs', rowGap: 'xl' },
          tablet: { cols: 2, rowGap: 'xs', colGap: 'xl' },
          mobile: { cols: 2, gap: 'xs' },
        }}
      >
        {columnI.length > 0 &&
          columnI.map(item => (
            <GridItem key={item.id} col="1">
              <FileCard
                {...item}
                {...item.file}
                extension={item.file.type}
                date={item.file.updatedAt}
                onSubmit={async (body: BodyType) =>
                  onSubmitFileForm({ ...body, filePath: item.file?.url })
                }
                recaptchaKey={recaptchaKey}
              />
            </GridItem>
          ))}
        {columnII.length > 0 &&
          columnII.map(item => (
            <GridItem key={item.id} col="1">
              <FileCard
                {...item} // TODO: refactor extra props
                {...item.file}
                date={item.file.updatedAt}
                extension={item.file.type}
                onSubmit={async (body: BodyType) =>
                  onSubmitFileForm({ ...body, filePath: item.file.url })
                }
                recaptchaKey={recaptchaKey}
              />
            </GridItem>
          ))}
      </Grid>
    </div>
  );
});

export default ContentBuilderTemplate;
